import { render, staticRenderFns } from "./MultipleTextQuestion.vue?vue&type=template&id=a49e2fd0&scoped=true&"
import script from "./MultipleTextQuestion.vue?vue&type=script&lang=ts&"
export * from "./MultipleTextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49e2fd0",
  null
  
)

export default component.exports